const NAME = "ONBOARDING_PROFILES";

export default NAME;
